import React, { Fragment } from 'react'
import {
  Typography,
  SpacerVertical,
  Frame,
} from '@klarna/bubble-ui'
import { Node } from '../types'
import getValueFromNodes from '../utilities/getValueFromNode'
import LegalText from '../components/LegalText/LegalText'
import config from '../config'
import LearnMoreTimeline from '../../interstitials/components/learn-more/Timeline'
import DisclaimerFrame from '../../interstitials/components/learn-more/bespoke/externalContent/DisclaimerFrame'

type DealsProps = {
  nodes: Node[]
  theme: string
};

export default function Deals(props: DealsProps) {
  const { nodes } = props
  const disclaimerText = getValueFromNodes(nodes, 'DISCLAIMER_TEXT')
  const timelineEntries = {
    0: getValueFromNodes(nodes, 'TIMELINE_STEP_1'),
    1: getValueFromNodes(nodes, 'TIMELINE_STEP_2'),
    2: getValueFromNodes(nodes, 'TIMELINE_STEP_3'),
    3: getValueFromNodes(nodes, 'TIMELINE_STEP_4'),
  }
  const backgroundThemeKey = props.theme === 'dark' ? 'darkBackgroundTheme' : 'backgroundTheme'

  return (
    <Fragment>
      <Typography
        id="learn-more-title"
        textToken="text-style/headings/titles/bold/quaternary"
      >
        {getValueFromNodes(nodes, 'TITLE')}
      </Typography>
      <SpacerVertical spaceToken="space.50" />
      {getValueFromNodes(nodes, 'SUB_TITLE') ? (
        <Typography textToken="text-style/text/paragraphs/body/regular">
          {getValueFromNodes(nodes, 'SUB_TITLE')}
        </Typography>
      ) : null}
      {disclaimerText ? (
        <>
          <SpacerVertical spaceToken="space.300" />
          <DisclaimerFrame
            title={disclaimerText}
            items={getValueFromNodes(nodes, 'DISCLAIMER_ITEM_LIST')}
          ></DisclaimerFrame>
          <SpacerVertical spaceToken="space.300" />
        </>
      ) : (
        <SpacerVertical spaceToken="space.300" />
      )}
      <SpacerVertical spaceToken="space.50" />
      <Typography
        id="learn-more-title"
        textToken="text-style/headings/titles/bold/grande"
        colorToken={'colors/text/subtle'}
      >
        {getValueFromNodes(nodes, 'TIMELINE_TITLE')}
      </Typography>
      <SpacerVertical spaceToken="space.200" />

      <Frame backgroundColorToken={config[backgroundThemeKey].frame_component}>
        <SpacerVertical spaceToken="space.100" />
        {getValueFromNodes(nodes, 'TIMELINE_STEP_1') && (
          <LearnMoreTimeline copy={timelineEntries} spacer={false} />
        )}
      </Frame>
      <SpacerVertical spaceToken="space.200" />
      <LegalText legalText={getValueFromNodes(nodes, 'LEGAL_TEXT')} />
    </Fragment>
  )
}